YP.CrmFinalizeCampaign = function() {
    return {
        init: function() {
            $('.js-form_finalize-send_date select').on('change', function(e){
                switch (parseInt($(this).val())) {
                    case 1:
                        $('.js-form_finalize-planed_date').show();
                        break;

                    default:
                        $('.js-form_finalize-planed_date').hide();
                        break;
                }
            });

            // Protection contre le double-clic sur le bouton d'envoi
            var submitted = false;
            $('.js-form_finalize').on('submit', function(e) {
                if (submitted) {
                    e.preventDefault();
                    return false;
                }

                submitted = true;
                $(this).find('button[type="submit"]').text('Envoi en cours...').css({ opacity: 0.6, cursor: 'not-allowed' });
            });
        }
    };
};
window.addEventListener("load", function() {
    if($('.js-form_finalize').length) {
        YP.CrmFinalizeCampaign().init();
    }
});
